import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { createAlert } from 'util/modules/Alert/redux/actions'
import { updatePassword } from 'panel/user/redux/actions'
import { ApplicationState } from 'AppReducer'
import { passwordValidate } from 'util/services/Validator'

const initialState = { oldPassword: '', newPassword: '', confirmPassword: '' }
const UpdatePassword: React.FC = () => {
  const { logged } = useSelector((state: ApplicationState) => state.userReducer)
  const [password, setPassword] = useState(initialState)

  const dispatch = useDispatch()
  const validation = passwordValidate(password.newPassword, password.confirmPassword)

  function handleSubmit (e: React.FormEvent): void {
    e.preventDefault()
    try {
      if (logged) {
        const { oldPassword, newPassword } = password
        if (newPassword && !validation.isValid) throw new Error(validation.warnings[0] || 'Senha Inválida')
        updatePassword(logged.id, { oldPassword, newPassword })(dispatch).then(res => {
          if (res?.status === 'success') {
            setPassword(initialState)
          }
        })
      } else {
        throw new Error('Usuário não encontrado')
      }
    } catch (error) {
      createAlert({ code: 500, title: 'Ocorreu um erro', message: error.message })(dispatch)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="row panel margin-top-16 mobile-responsive">
      <h2 className="col-12 margin-bottom-16">Atualizar Senha?</h2>
      <div className="form-control col-4">
        <label>Senha Anterior</label>
        <input
          type="password"
          value={password.oldPassword}
          autoComplete="new-password"
          onChange={(e): void => setPassword({ ...password, oldPassword: e.target.value })}
          required
        />
      </div>
      <div className="form-control col-4">
        <label>Nova Senha</label>
        <input
          type="password"
          value={password.newPassword}
          autoComplete="new-password"
          onChange={(e): void => setPassword({ ...password, newPassword: e.target.value })}
          required
        />
      </div>
      <div className="form-control col-4">
        <label>Confirmar Senha</label>
        <input
          type="password"
          value={password.confirmPassword}
          autoComplete="new-password"
          onChange={(e): void => setPassword({ ...password, confirmPassword: e.target.value })}
          required
        />
      </div>
      <p className="col-12 text-center">
        {validation.warnings?.[0] || <>&nbsp;</>}
      </p>

      <div className="row margin-top-16 justify-end responsive-btn">
        <button className="primary" style={{ width: 300 }}>
          Atualizar Senha
        </button>
      </div>
    </form>
  )
}

export default UpdatePassword
